import React from 'react';
import './Banner.css';

const Banner = ({ items, speed = 25000 }) => {
  return (
    <div className="banner-inner">
      <div className="banner-wrapper">
        <section style={{ "--speed": `${speed}ms` }}>
          {items.map((item, index) => (
            <div className="banner-item" key={`${item.name}-1-${index}`}>
              {item.icon && (
                <div className="tech-icon">
                  {item.icon}
                </div>
              )}
              <span className="tech-name">{item.name}</span>
            </div>
          ))}
        </section>
        <section style={{ "--speed": `${speed}ms` }}>
          {items.map((item, index) => (
            <div className="banner-item" key={`${item.name}-2-${index}`}>
              {item.icon && (
                <div className="tech-icon">
                  {item.icon}
                </div>
              )}
              <span className="tech-name">{item.name}</span>
            </div>
          ))}
        </section>
        <section style={{ "--speed": `${speed}ms` }}>
          {items.map((item, index) => (
            <div className="banner-item" key={`${item.name}-3-${index}`}>
              {item.icon && (
                <div className="tech-icon">
                  {item.icon}
                </div>
              )}
              <span className="tech-name">{item.name}</span>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default Banner;
